import { useContext, useState, useEffect } from 'react';
import helpDoc from '../assets/tutorial_CBC-dashboard.pdf';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginCnpj, loginCpf } from '../services';
import { alpha } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Logout from '@mui/icons-material/Logout';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu'; // Importar o ícone do menu
import Settings from '@mui/icons-material/Settings';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import ClubeCertoLogo from '../assets/clubecerto.png';
import HelpIcon from '@mui/icons-material/Help';
import DashboardContext from '../context/DashboardContext';
import Drawer from '@mui/material/Drawer'; // Importar o Drawer
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

export default function Header() {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [sizeLogo, setSizeLogo] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false); // Estado para controlar o Drawer
  const {
    isMemberDrawerOpen,
    setClientId,
    setClientCnpj,
    setClientUser,
    setClientPassword,
    setIsLoggedIn,
    clientLogo,
    admin,
    setAdmin,
    master,
    setMaster,
    clientId,
    permissions,
  } = useContext(DashboardContext);
  const { pathname } = useLocation();
  const navigation = useNavigate();

  useEffect(() => {
    const LOGO = new Image();
    LOGO.src = clientLogo;
    LOGO.onload = () => {
      setSizeLogo({
        width: LOGO.naturalWidth,
        height: LOGO.naturalHeight,
      });
    };
  }, [clientLogo]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  async function verifyAdmin() {
    const typeClient = sessionStorage.getItem('typeClient');
    const clientUser = JSON.parse(sessionStorage.getItem('clientUser'));
    const password = JSON.parse(sessionStorage.getItem('clientPassword'));
    const clientCpf = JSON.parse(localStorage.getItem('clientCpf'));

    if (typeClient === 'cpf') {
      const worker = {
        cpf: clientCpf,
        senha: password,
      };
      const data = await loginCpf(worker);
      if (data.admin === 1) {
        setAdmin(false);
        setMaster(true);
      } else if (data.admin === 2) {
        setAdmin(true);
        setMaster(false);
      } else {
        setAdmin(false);
        setMaster(false);
      }
    } else {
      const password = JSON.parse(sessionStorage.getItem('clientPassword'));
      const cnpj = JSON.parse(localStorage.getItem('clientCnpj'));
      const { id } = await loginCnpj(clientUser, password, cnpj);

      if (!!id) {
        setAdmin(true);
      } else {
        setAdmin(false);
        handleLogout();
      }
    }
  }

  const handleLogout = () => {
    handleCloseUserMenu();

    sessionStorage.removeItem('clientId');
    sessionStorage.removeItem('clientUser');
    sessionStorage.removeItem('clientPassword');
    sessionStorage.removeItem('isLoggedIn');

    setClientId('');
    setClientCnpj('');
    setClientUser('');
    setClientPassword('');
    setIsLoggedIn(false);
    setAdmin(false);

    navigation('/userVerify');
  };

  // HOOKS
  useEffect(() => {
    let isMounted = true;
    verifyAdmin();
    return () => {
      isMounted = false;
    };
  }, []);

  // Lista de itens de navegação
  const navItems = [
    permissions?.panel && {
      label: 'Painel',
      onClick: () => navigation('/panel'),
      active: pathname.includes('panel'),
    },
    clientId == 1176 && {
      label: 'Saúde',
      onClick: () => navigation('/saude'),
      active: pathname.includes('saude'),
    },
    (admin || master === true) && {
      label: 'Associados',
      onClick: () => navigation('/members'),
      active: pathname.includes('members'),
    },
    permissions?.establishments && {
      label: 'Estabelecimentos',
      onClick: () => navigation('/establishments'),
      active: pathname.includes('establishments'),
    },
    admin === true && {
      label: 'Funcionários',
      onClick: () => navigation('/workers'),
      active: pathname.includes('workers'),
    },
  ].filter(Boolean); // Filtra itens falsos ou undefined

  // Conteúdo do Drawer (menu lateral)
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <img
        src={ClubeCertoLogo}
        alt="logo do clube certo"
        style={{ margin: '16px auto', width: '150px' }}
      />
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton
              sx={{ textAlign: 'center' }}
              onClick={item.onClick}
              selected={item.active}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        open={isMemberDrawerOpen}
        sx={{
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
          backgroundColor: alpha('#f5f5f5', 0.7),
          boxShadow: '0px 0px 15px 0px rgb(88 88 88 / 20%)',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            {/* Botão do menu hamburguer (aparece em telas pequenas) */}
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { md: 'none' } }}
            >
              <MenuIcon color="primary" />
            </IconButton>

            {/* Logo (ajustada para telas grandes e pequenas) */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexGrow: { xs: 1, md: 0 },
              }}
            >
              <img
                src={ClubeCertoLogo}
                alt="logo do clube certo"
                style={{ marginRight: '16px', width: '150px' }}
              />
            </Box>

            {/* Botões de navegação (aparecem em telas médias e grandes) */}
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  color={item.active ? 'primary' : 'carbonGray'}
                  onClick={item.onClick}
                  sx={{ my: 2, display: 'block' }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>

            {/* Logo do cliente */}
            {sizeLogo !== null ? (
              <Box
                sx={{
                  backgroundClip: 'border-box',
                  backgroundColor: 'white',
                  backgroundImage: `url(${clientLogo})`,
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  borderRadius: '8px',
                  boxShadow: '0px 0px 10px 0px rgb(88 88 88 / 20%) inset',
                  color: 'black',
                  filter: 'opacity(90%)',
                  height: '60px',
                  mr: 3,
                  width: `${(sizeLogo.width / sizeLogo.height) * 60 + 20}px`,
                  display: { xs: 'none', md: 'block' },
                }}
              />
            ) : (
              <></>
            )}

            {/* Menu de opções do usuário */}
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Mais opções">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar sx={{ backgroundColor: 'unset' }}>
                    <PersonIcon color="primary" />
                  </Avatar>
                </IconButton>
              </Tooltip>
              <Menu
                sx={{
                  '& .MuiPaper-root': { borderRadius: '8px' },
                  mt: '45px',
                }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem
                  onClick={() => {
                    handleCloseUserMenu();
                    navigation('/settings');
                  }}
                  sx={{ alignItems: 'center', display: 'flex' }}
                >
                  <Settings sx={{ mr: 1 }} />
                  <Typography textAlign="center">Configurações</Typography>
                </MenuItem>
                <a
                  href={helpDoc}
                  download={true}
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  <MenuItem sx={{ alignItems: 'center', display: 'flex' }}>
                    <HelpIcon sx={{ fontSize: '30px', mr: 0.5 }} />
                    <Typography textAlign="center">Ajuda</Typography>
                  </MenuItem>
                </a>
                <MenuItem onClick={handleLogout}>
                  <Typography sx={{ alignItems: 'center', display: 'flex' }} textAlign="center">
                    <Logout sx={{ mr: 1 }} />
                    Sair
                  </Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Drawer para o menu hamburguer (aparece em telas pequenas) */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Melhora o desempenho em dispositivos móveis
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 240,
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
}
